import { Paper, Stack } from '@mui/material'
import React from 'react'
import { customStyles } from '../../../styles'
import { MainButton, MainInput, SmallText } from '../../helpers'

export const OrderComments = () => {
  return (
    <Paper sx={{ padding: 1, marginTop: 3 }}>
      <Stack spacing={2}>
        <SmallText text="¿Tienes algún comentario de este pedido?"/>
        <MainInput placeholder="Ayuda a nuestra comunidad con tus comentarios" height={150}/>
        <MainButton text="Enviar" variant="outlined" size={ customStyles.buttonSize.full }/>
      </Stack>
    </Paper>
  )
}
